/**
 * Disparo de eventos personalizados de Plausible, en un solo lugar.
 *
 * POR QUE EXISTE. Hasta el 2026-08-04 cada sitio que mandaba un evento repetia
 * su propio guard: `LocalForm` lo hace con `typeof window !== 'undefined' &&
 * window.plausible`, y `WhatsAppCtaButton` / `WhatsAppLeadLink` con un cast a
 * `unknown`. Tres formas de escribir la misma linea, y cada nueva tenia que
 * acordarse del guard. Si falta, el evento revienta en SSR o en el navegador de
 * un visitante con bloqueador — que es la mayoria en un sitio de marketing.
 *
 * EL GUARD NO ES OPCIONAL. `window.plausible` no existe en tres situaciones muy
 * normales: durante el render en servidor, si el script todavia no cargo, y si
 * un bloqueador de anuncios lo tumbo. Ninguna de esas debe romper el flujo del
 * usuario — el analitico es observacion, no funcionalidad.
 */
'use client'

type PlausibleFn = (evento: string, opts?: { props?: Record<string, string | number> }) => void

export function trackEvent(evento: string, props?: Record<string, string | number>): void {
  if (typeof window === 'undefined') return
  const plausible = (window as { plausible?: PlausibleFn }).plausible
  if (typeof plausible !== 'function') return
  try {
    plausible(evento, props ? { props } : undefined)
  } catch {
    // Un analitico jamas debe tumbar la pagina que observa.
  }
}
